export default "__VITE_ASSET__ChVPszmr__"